<script setup lang="ts">
import DRBtn from "@/components/UI/DRBtn.vue";
import UiChangesItem from "./UiChangesItem.vue";

/** Étape 4 : le menu fichier, et où régler l'affichage. */
const emit = defineEmits<{ openDisplay: [] }>();

// Mêmes icônes, même ordre que le menu fichier (CanvasFileMenu).
const FILE_ITEMS = [
  { key: "backHome", icon: "house" },
  { key: "export", icon: "download-simple" },
  { key: "backups", icon: "clock-counter-clockwise" },
  { key: "activity", icon: "clipboard-text" },
  { key: "display", icon: "sliders-horizontal" },
  { key: "fullscreen", icon: "corners-out" },
] as const;
</script>

<template>
  <div>
    <div class="ui-section-title">
      {{ $t("canvas:uiChanges.menu.fileTitle") }}
    </div>
    <p class="ui-intro">{{ $t("canvas:uiChanges.menu.fileIntro") }}</p>
    <div class="file-items">
      <UiChangesItem
        v-for="item in FILE_ITEMS"
        :key="item.key"
        :icon="item.icon"
        :title="$t(`canvas:header.fileMenu.${item.key}`)"
        :text="$t(`canvas:uiChanges.menu.items.${item.key}`)"
      />
    </div>

    <div class="display-card">
      <div class="ui-section-title">
        {{ $t("canvas:uiChanges.menu.displayTitle") }}
      </div>
      <p class="display-text">{{ $t("canvas:uiChanges.menu.displayText") }}</p>
      <DRBtn
        variant="outline-white"
        size="sm"
        phosphor-icon="sliders-horizontal"
        :label="$t('canvas:uiChanges.menu.openDisplay')"
        @click="emit('openDisplay')"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ui-section-title {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}

.ui-intro {
  margin: 2px 0 12px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
}

.file-items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(250px, 100%), 1fr));
  gap: 12px 20px;
}

.display-card {
  margin-top: 20px;
  padding: 14px;
  border: 1px solid var(--canvas-btn-mode-border);
  border-radius: 12px;
  background-color: var(--canvas-btn-mode-bg);
}

.display-text {
  margin: 4px 0 12px;
  font-size: 13px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.8);
}
</style>
